var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBagstageQtb(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 56,
    viewBox: "0 0 55 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3784_14565",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 11,
    width: 33,
    height: 33
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.7656,
    y: 11.5,
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3784_14565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.899 29.1666L23.0323 26.3C22.7878 26.0555 22.4767 25.9333 22.099 25.9333C21.7212 25.9333 21.4101 26.0555 21.1656 26.3C20.9212 26.5444 20.799 26.8555 20.799 27.2333C20.799 27.6111 20.9212 27.9222 21.1656 28.1666L24.9656 31.9666C25.2323 32.2333 25.5434 32.3666 25.899 32.3666C26.2545 32.3666 26.5656 32.2333 26.8323 31.9666L34.3656 24.4333C34.6101 24.1889 34.7323 23.8778 34.7323 23.5C34.7323 23.1222 34.6101 22.8111 34.3656 22.5666C34.1212 22.3222 33.8101 22.2 33.4323 22.2C33.0545 22.2 32.7434 22.3222 32.499 22.5666L25.899 29.1666ZM18.4323 39.5C17.699 39.5 17.0712 39.2389 16.549 38.7166C16.0267 38.1944 15.7656 37.5666 15.7656 36.8333V18.1666C15.7656 17.4333 16.0267 16.8055 16.549 16.2833C17.0712 15.7611 17.699 15.5 18.4323 15.5H24.0323C24.3212 14.7 24.8045 14.0555 25.4823 13.5666C26.1601 13.0778 26.9212 12.8333 27.7656 12.8333C28.6101 12.8333 29.3712 13.0778 30.049 13.5666C30.7267 14.0555 31.2101 14.7 31.499 15.5H37.099C37.8323 15.5 38.4601 15.7611 38.9823 16.2833C39.5045 16.8055 39.7656 17.4333 39.7656 18.1666V36.8333C39.7656 37.5666 39.5045 38.1944 38.9823 38.7166C38.4601 39.2389 37.8323 39.5 37.099 39.5H18.4323ZM18.4323 36.8333H37.099V18.1666H18.4323V36.8333ZM27.7656 17.1666C28.0545 17.1666 28.2934 17.0722 28.4823 16.8833C28.6712 16.6944 28.7656 16.4555 28.7656 16.1666C28.7656 15.8778 28.6712 15.6389 28.4823 15.45C28.2934 15.2611 28.0545 15.1666 27.7656 15.1666C27.4767 15.1666 27.2378 15.2611 27.049 15.45C26.8601 15.6389 26.7656 15.8778 26.7656 16.1666C26.7656 16.4555 26.8601 16.6944 27.049 16.8833C27.2378 17.0722 27.4767 17.1666 27.7656 17.1666Z",
    fill: "var(--color-text-primary)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBagstageQtb);
export default __webpack_public_path__ + "static/media/bagstage_qtb.cd486b69360f37e88279103e68fc14fd.svg";
export { ForwardRef as ReactComponent };